import React, { Component } from "react";
import styles from "./CollaboratorSpace.local.scss";
import classnames from "classnames";

class CapacityPlaningChartFetching extends Component {
  render() {
    let monthsDetails = [];
    for (let i = 0; i < 6; i++) {
      monthsDetails.push(
        <div key={i} className={styles.months_cp}>
          <div
            className={classnames(styles.icon_month_frame, styles.gradiant)}
          />
          <div
            className={classnames(
              styles.icon_month_number_frame,
              styles.gradiant
            )}
          />
        </div>
      );
    }
    return (
      <div className={styles.fetching_chart}>
        <div className={styles.chart_cp}>
          <div className={styles.chart_cp_header}>
            <div
              className={classnames(styles.icon_chart_frame, styles.gradiant)}
            />
            <br />

            <div
              className={classnames(styles.month_details, styles.gradiant)}
            />
          </div>
        </div>
        {monthsDetails}
      </div>
    );
  }
}

export default CapacityPlaningChartFetching;



// WEBPACK FOOTER //
// ./src/components/CollaboratorSpace/CapacityPlaningChartFetching.js